import React from 'react'
import logo from './logo.png'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import { Link } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'

const styles = (theme) => ({
  page: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(3),
    background:
      'radial-gradient(circle at top left, rgba(91,108,255,0.18), transparent 36%), radial-gradient(circle at bottom right, rgba(124,107,242,0.14), transparent 32%), #f5f7fb',
  },
  card: {
    width: '100%',
    maxWidth: 480,
    background: '#fff',
    borderRadius: 24,
    border: '1px solid #eef2f7',
    boxShadow: '0 18px 48px rgba(15, 23, 42, 0.08)',
    padding: theme.spacing(5, 4),
    textAlign: 'center',
  },
  title: {
    fontWeight: 700,
    marginTop: theme.spacing(2.5),
    marginBottom: theme.spacing(1),
  },
  subtitle: {
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(3),
  },
  actions: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
  },
  link: {
    textDecoration: 'none',
  },
})

function Home({ classes }) {
  return (
    <div className={classes.page}>
      <div className={classes.card}>
        <img src={logo} className="App-logo" alt="logo" />
        <Typography variant="h5" className={classes.title}>
          GOLAB Gerontech Platform
        </Typography>
        <Typography className={classes.subtitle}>
          Gerontech OS
        </Typography>
        <div className={classes.actions}>
          <Link to="/login" className={classes.link}>
            <Button fullWidth variant="contained" color="primary">
              醫護人員登入
            </Button>
          </Link>
          <Link to="/user/login" className={classes.link}>
            <Button fullWidth variant="outlined" color="primary">
              個案登入
            </Button>
          </Link>
          <Link to="/user/signup" className={classes.link}>
            <Button fullWidth variant="text" color="primary">
              個案註冊
            </Button>
          </Link>
        </div>
      </div>
    </div>
  )
}

export default withStyles(styles)(Home)
